class DisputeClientOwner {
  /**
   * @param {number} id - Unique identifier for the owner.
   * @param {string} name - Name of the owner.
   */
  constructor(data) {
    /** @type {number} */
    this.id = data.id
    /** @type {string} */
    this.name = data.name
  }
}

class DisputeClientType {
  /**
   * @param {number} id - Unique identifier for the type.
   * @param {string} name - Name of the type.
   */
  constructor(data) {
    /** @type {number} */
    this.id = data.id
    /** @type {string} */
    this.name = data.name
  }
}

export default class DisputeClientDetails {
  /**
   * @param {number} id - Unique identifier for the client.
   * @param {string} name - Name of the client.
   * @param {string} payType - Pay type for the client.
   * @param {DisputeClientOwner} owner - Owner of the client.
   * @param {DisputeClientType} type - Type of the client.
   */
  constructor(data) {
    /** @type {number} */
    this.id = data.id
    /** @type {string} */
    this.name = data.name
    /** @type {string} */
    this.payType = data.payType
    /** @type {DisputeClientOwner} */
    this.owner = new DisputeClientOwner(data.owner)
    /** @type {DisputeClientType} */
    this.type = new DisputeClientType(data.type)
  }
}
